import currency from 'currency.js';
import { parseJSON, isValid, isBefore, isAfter } from 'date-fns';

export const basicSort = (a, b) => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

export const currencySort = (a, b) => {
  const amountA = currency(a).value;
  const amountB = currency(b).value;

  return basicSort(amountA, amountB);
};

export const dateSort = (a, b) => {
  // if invalid/null date, replace with now
  const dateA = isValid(parseJSON(a)) ? parseJSON(a) : new Date();
  const dateB = isValid(parseJSON(b)) ? parseJSON(b) : new Date();

  if (isBefore(dateA, dateB)) {
    return -1;
  }

  if (isAfter(dateA, dateB)) {
    return 1;
  }

  return 0;
};
